import { LifeBuoy, Mail, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const SUPPORT_WHATSAPP_URL = 'https://wa.me/17372370834';
const SUPPORT_EMAIL_URL = 'mailto:support@hookmyapp.com';

/**
 * Header Support menu — dropdown with the two contact channels (WhatsApp,
 * email). Trigger matches the HeaderButton look (see AppHeader's Docs action).
 */
export function SupportMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            variant="ghost"
            size="sm"
            className="gap-1.5 text-muted-foreground"
            aria-label="Support"
          >
            <LifeBuoy className="size-4" />
            <span className="hidden md:inline">Support</span>
          </Button>
        }
      />
      <DropdownMenuContent align="end" className="w-48 p-2">
        <DropdownMenuItem
          className="gap-3 rounded-md p-3"
          onClick={() =>
            window.open(SUPPORT_WHATSAPP_URL, '_blank', 'noopener,noreferrer')
          }
        >
          <MessageCircle className="size-4 shrink-0" />
          <span className="text-sm font-medium">WhatsApp</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-3 rounded-md p-3"
          // Same tab, not window.open: a `mailto:` opened into `_blank` hands
          // the new tab to the OS mail handler and, when there isn't one,
          // leaves the customer staring at a blank page with no way back to
          // what they were doing. Reported as "the email support option opens
          // an empty page" (AIT-454). Assigning location fires the handler
          // without ever creating a tab.
          onClick={() => {
            window.location.href = SUPPORT_EMAIL_URL;
          }}
        >
          <Mail className="size-4 shrink-0" />
          <span className="text-sm font-medium">Email</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
